<!--Mode-->
<!-- <div class="OptionGrid">
    <input class="RAD" type="radio" name="ViewMode" [(ngModel)]="ViewMode" value="Role" id="Role">
    <label for="Role">By Role</label>

    <input class="RAD LeftMargin" type="radio" name="ViewMode" [(ngModel)]="ViewMode" value="Email" id="Email">
    <label for="Email">By Email</label>
</div> -->

<div *ngIf="ViewMode == 'Role'">
	<caass-ms-notification-by-role> </caass-ms-notification-by-role>
</div>

<div *ngIf="ViewMode == 'Email'">
	<caass-ms-notification-by-email> </caass-ms-notification-by-email>
</div>
